import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const agreementsAnalysis = axios.create({
  baseURL: queryParams.apiVersion + "pages/agreements_page/agreements_analysis"
});

export const agreementsAnalysisApi = {
  getFilters(params) {
    return agreementsAnalysis.post("/get_filters", params);
  },
  getData(params) {
    return agreementsAnalysis.post("/get_data", params);
  }
};
